import { RoleAssignment } from '@app/models/account/role-assignment.model';
import { File } from '@app/models/common/file.model';
import { Paystub } from '@app/models/payroll/paystub.model';
import { Account } from '@models/account/account.model';
import { Email } from '@models/account/email.model';
import { Password } from '@models/account/password.model';
import { Role } from '@models/account/role.model';
import { BenefitPlan } from '@models/benefits/benefit-plan.model';
import { Notification } from '@models/common/notification.model';
import { Company } from '@models/company/company.model';
import { Department } from '@models/company/department.model';
import { Job } from '@models/company/job.model';
import { Office } from '@models/company/office.model';
import { DataValue } from '@models/employee/data-value.model';
import { Employee } from '@models/employee/employee.model';
import { Feedback } from '@models/performance/feedback.model';
import { Goal } from '@models/performance/goal.model';
import { Review } from '@models/performance/review.model';
import { Survey } from '@models/performance/survey.model';
import { Template } from '@models/performance/template.model';
import { Permission } from '@models/permissions/permission.model';
import { CompanySetting } from '@models/settings/company-setting.model';
import { DataFieldGroup } from '@models/settings/data-field-group.model';
import { DataField } from '@models/settings/data-field.model';

export const RequiredPermissions: string[] = [
    // Modules
    'accessCompany',
    'accessEmployees',

    // Common Module
    ...File.permission.some('search', 'create', 'view', 'delete'),
    'serve.file',
    'download.file',
    ...Notification.permission.all,

    // Account Module
    ...Account.permission.some('view'),
    ...Email.permission.all,
    ...RoleAssignment.permission.view,
    ...Password.permission.some('create'),
    ...Permission.permission.some('search'),
    ...Role.permission.view,

    // Company Module
    'view.companyDetail',
    ...Company.permission.some('view'),
    ...Department.permission.view,
    ...Job.permission.view,
    ...Office.permission.view,
    ...CompanySetting.permission.some('search'),
    ...DataField.permission.view,
    ...DataFieldGroup.permission.view,

    // ...Reminder.permission.all,

    // Performance
    ...Template.performancePermission.some('view', 'search'),
    ...Template.surveyPermission.some('view', 'search'),
    ...Review.permission.some('view', 'search'),
    ...Goal.permission.some('view', 'search'),
    ...Feedback.permission.some('view', 'search'),
    ...Survey.permission.some('view', 'search'),

    ...Paystub.permission.some('view', 'search'),

    // Employee Module
    ...Employee.permission.some('search', 'view'),
    ...DataValue.permission.all,
    // ...Salary.permission.some('search', 'view', 'create'), employees can always update own without permission
    // ...BankAccount.permission.some('view', 'update', 'create', 'delete'),  employees can always update own without permission
    ...BenefitPlan.permission.view,
];
